import Stack from '@mui/material/Stack';
import { SxProps, Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { varAlpha } from '@theme/styles/utils';

// ----------------------------------------------------------------------

interface EmptyContentProps {
  sx?: SxProps<Theme>;
  action?: React.ReactNode;
  filled?: boolean;
  slotProps?: {
    img?: SxProps<Theme>;
    title?: SxProps<Theme>;
    description?: SxProps<Theme>;
  };
  description?: string;
  title?: string;
}

export function EmptyContent({
  sx,
  action,
  filled,
  slotProps,
  description,
  title = 'No data',
  ...other
}: EmptyContentProps) {
  return (
    <Stack
      alignItems="center"
      flexGrow={1}
      justifyContent="center"
      sx={{
        px: 3,
        height: 1,
        ...(filled && {
          borderRadius: 2,
          bgcolor: (theme) => varAlpha((theme.palette.grey as any)['500Channel'], 0.04),
          border: (theme) =>
            `dashed 1px ${varAlpha((theme.palette.grey as any)['500Channel'], 0.08)}`,
        }),
        ...sx,
      }}
      {...other}
    >
      {title && (
        <Typography
          component="span"
          sx={{
            mt: 1,
            textAlign: 'center',
            ...slotProps?.title,
            color: 'text.disabled',
          }}
          variant="h6"
        >
          {title}
        </Typography>
      )}

      {description && (
        <Typography
          sx={{
            mt: 1,
            textAlign: 'center',
            color: 'text.disabled',
            ...slotProps?.description,
          }}
          variant="caption"
        >
          {description}
        </Typography>
      )}

      {action && action}
    </Stack>
  );
}
